import { FlatList, FlatListProps, ListRenderItemInfo, StyleProp, StyleSheet, TextStyle, View } from 'react-native'

import { Color, Spacing } from '../../style'

import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bullet: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: Color.premiumBlack,
    marginRight: Spacing.XS,
  },
})

export interface Props extends Omit<FlatListProps<string>, 'data' | 'renderItem'> {
  data: string[]
  textStyle?: StyleProp<TextStyle>
}

const TextList = (props: Props) => {
  const { data, style, textStyle, ...otherProps } = props

  function renderItem(info: ListRenderItemInfo<string>) {
    const { item } = info
    const { color } = StyleSheet.flatten(textStyle)
    const bulletStyle = [styles.bullet, color && { backgroundColor: color }]
    return (
      <View style={styles.row}>
        <View style={bulletStyle} />
        <Text style={textStyle}>{item}</Text>
      </View>
    )
  }

  return <FlatList data={data} renderItem={renderItem} style={[styles.container, style]} {...otherProps} />
}

export default TextList
